module.exports = __webpack_public_path__ + "img/stadia-ios-pwa-framed.e763402d.webp";